import {createActions} from 'reduxsauce';

export const {Types: MesCommandesTypes, Creators: MesCommandesActionCreators} = createActions ({
    mesCommandesStart: [null],
    mesCommandesSuccess: ['data'],
    mesCommandesFailure: ['error'],
    mesTicketsStart: [null],
    mesTicketsSuccess: ['data'],
    mesTicketsFailure: ['error']
});